import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=7ee4bebe&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&id=7ee4bebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee4bebe",
  null
  
)

export default component.exports